<template>
    <section class="panel panel-featured-left panel-featured-primary">
        <div class="panel-body">
            <div class="widget-summary">
                <div class="widget-summary-col widget-summary-col-icon">
                    <div class="summary-icon bg-primary">
                        <i class="fa fa-life-ring"></i>
                    </div>
                </div>
                <div class="widget-summary-col">
                    <div class="summary">
                        <h4 class="title">¿Necesitas Ayuda?</h4>
                        <div>
                            Envíanos un mensaje a través de nuestro portal de clientes.
                        </div>
                    </div>
                    <div class="summary-footer">
                        <router-link class="text-muted text-uppercase" to="/features/contact">
                            (enviar mensaje)
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    module.exports = {
        name: 'support-info-widget',
        data: function () {
            return {
                isLoading: true
            }
        },
        mounted: function(){
            this.$nextTick(function () {
                this.refresh();
            });
        },
        methods: {
            refresh: function () {
                this.isLoading = false;
            }
        }
    }
</script>